import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import styles from './style.module.scss';

export interface IToggleProps {
    showUnassociated: boolean;
}

const ToggleAssociatedRecordsIcon = ({ showUnassociated }: IToggleProps) => {
    return (
        <div className={cn('k-d-flex fa-stack', styles.iconStyle)}>
            <FontAwesomeIcon className={cn('fa-stack-1x')} fontSize={16} icon={['fal', 'link']} />
            <FontAwesomeIcon
                className={cn('fa-stack-1x')}
                fontSize={13}
                icon={showUnassociated ? ['far', 'eye'] : ['far', 'eye-slash']}
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '1px 0px',
                    position: 'absolute',
                    top: '40%',
                    left: '60%',
                }}
            />
        </div>
    );
};

export default ToggleAssociatedRecordsIcon;
